import { Observable } from 'rxjs';
import { ActionViewMap } from './action-view.mapper';
import { FieldTranslation } from '@floori-web-components';

export interface ActionContainerDialogData {
    containerData$: Observable<ActionContainerData>;
    actionViewMap: ActionViewMap;
    actionButtonMap: ActionViewMap;
}

export interface ActionContainerButtonData {
    display: boolean;
    icon?: string;
    notification?: boolean;
}

export interface ActionContainerData {
    addHiddenUIClass: boolean;
    headerType: string;
    headerLabel: FieldTranslation | string;
    headerIcon: string;
    headerMessage: string;
    isDialog: boolean;
    isEpoxy: boolean;
    allowDrag: boolean;
    showCloseButton: boolean;
    primaryButton: ActionContainerButtonData;
    secondaryButton?: ActionContainerButtonData;
    tertiaryButton?: ActionContainerButtonData;
    showSelector: boolean;
    selectorValue: string;
    disableHeaderLabelTranslation?: boolean;
}
